// DropdownButton.tsx
import * as React from 'react';
import Button, { ButtonProps } from '@minecraft.button';
import { BaseDropdownButton } from './BaseDropdownButton';
import { DropdownItemProps, OptionalProps } from './types';

export interface DropdownButtonProps extends OptionalProps {
  toggleLabel: string;
  toggleProps: Partial<Omit<ButtonProps, 'children' | 'qaId' | 'testId'>>;
  menuItemsProps: DropdownItemProps[];
  menuAlign?: 'right' | 'left';
  block?: boolean;
  mobileBlock?: boolean;
}

export const DropdownButton = (props: DropdownButtonProps) => (
  <BaseDropdownButton
    {...props}
    toggleComponent={Button}
    toggleChildren={props.toggleLabel}
    toggleExtraProps={{ caret: true, fixedWidth: false }}
    menuExtraProps={props.menuAlign === 'right' ? { right: true } : {}}
  />
);
